import {Comment, Member} from '../app-context';
import {YUTAWATANABE_NAME} from './constants';

/**
 * コメント配列を受け取り、likes_member の中で
 * name が "渡邊雄太" のメンバーを先頭に移動する
 */
export function reorderLikesMember(comments: Comment[]): Comment[] {
    return comments.map((comment) => {
        // likes_memberが存在しない場合は空配列で初期化
        if (!comment.likes_member || !Array.isArray(comment.likes_member)) {
            return {
                ...comment,
                likes_member: []
            };
        }

        const targetMember = comment.likes_member.find((m: Member) => m.name === YUTAWATANABE_NAME);
        if (!targetMember) {
            // 該当メンバーがいなければ変更せず return
            return comment;
        }

        // "渡邊雄太" 以外のメンバー一覧
        const otherMembers = comment.likes_member.filter((m: Member) => m.name !== YUTAWATANABE_NAME);
        // 先頭に "渡邊雄太" を配置した新しい配列を作成
        const reorderedLikesMembers = [targetMember, ...otherMembers];

        // 新しいコメントオブジェクトを返す（immutable）
        return {
            ...comment,
            likes_member: reorderedLikesMembers
        };
    });
}